export const INDEX_FAIL = " INDEX_FAIL";
export const INDEX_LOADING = " INDEX_LOADING";
export const INDEX_SUCCESS = " INDEX_SUCCESS";

export const CREATE_MANUFACTURER_LOADING = "CREATE_MANUFACTURER_LOADING";
export const CREATE_MANUFACTURER_SUCCESS = "CREATE_MANUFACTURER_SUCCESS";
export const CREATE_MANUFACTURER_ERROR = "CREATE_MANUFACTURER_ERROR";
export const CREATE_MANUFACTURER_UPDATE = "CREATE_MANUFACTURER_UPDATE";
export const CREATE_MANUFACTURER_CLEAR = "CREATE_MANUFACTURER_CLEAR";
